import { lazyLoadView } from "@/router/routes";

export default [
  {
    path: "/static/employee",
    name: "staticEmployee",
    component: lazyLoadView("static/Employee.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/static/login",
    name: "staticLogin",
    component: lazyLoadView("static/Login.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
    },
  },
  // {
  //   path: "/static/masterdatamanagement",
  //   name: "masterDataManagement",
  //   component: lazyLoadView("static/MasterDataManagement.vue"),
  //   meta: {
  //     authRequired: false,
  //   },
  // },
  {
    path: "/static/usermanagement",
    name: "userManagement",
    component: lazyLoadView("static/UserManagement.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/static/subscriptions",
    name: "subscriptions",
    component: lazyLoadView("static/Subscriptions.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/static/customer",
    name: "customer",
    component: lazyLoadView("static/CustomerList.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/static/addcustomer",
    name: "addcustomer",
    component: lazyLoadView("static/AddCustomer.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/static/payment",
    name: "payment",
    component: lazyLoadView("static/Payment.vue"),
    meta: {
      authRequired: false,
      layout: "CommonLayout",
    },
  },
  {
    path: "/static/thankyou",
    name: "thankyou",
    component: lazyLoadView("static/Thankyou.vue"),
    meta: {
      authRequired: false,
      layout: "CommonLayout",
    },
  },
  {
    path: "/static/register",
    name: "register",
    component: lazyLoadView("static/Register.vue"),
    meta: {
      authRequired: false,
      layout: "CommonLayout",
    },
  },
  {
    path: "/static/createpassword",
    name: "createpassword",
    component: lazyLoadView("static/Createpassword.vue"),
    meta: {
      authRequired: false,
      layout: "PublicLayout",
      hasBackGroundImage: false,
      background: "#ff9b44",
    },
  },
  {
    path: "/static/404",
    name: "static404",
    component: lazyLoadView("static/404.vue"),
    meta: {
      authRequired: false,
    },
  },
];
